import { c as _c } from "react/compiler-runtime";
import type { TenantScope } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import { decryptOptionFromTenantScope, useDecryptOptions } from '@/components/roles';
import { isSandboxOnly } from '@/components/roles/utils/scope-environments';
const useGetRoleText = () => {
  const $ = _c(6);
  const {
    t
  } = useTranslation("roles");
  const {
    getLabel
  } = useDecryptOptions();
  let t0;
  if ($[0] !== getLabel || $[1] !== t) {
    t0 = scope => {
      const decryptOption = decryptOptionFromTenantScope(scope);
      if (decryptOption) {
        return t(_temp, {
          field: getLabel(decryptOption)
        });
      }
      if (scope.kind === "admin") {
        return t(_temp2);
      }
      if (scope.kind === "read") {
        return t(_temp3);
      }
      if (scope.kind === "onboarding_configuration") {
        return t(_temp4);
      }
      if (scope.kind === "api_keys") {
        return t(_temp5);
      }
      if (scope.kind === "org_settings") {
        return t(_temp6);
      }
      if (scope.kind === "manual_review") {
        return t(_temp7);
      }
      if (scope.kind === "write_entities") {
        return t(_temp8);
      }
      if (scope.kind === "invoke_vault_proxy") {
        return t(_temp9);
      }
      if (scope.kind === "decrypt") {
        return t(_temp10);
      }
      if (scope.kind === "decrypt_onboarding_data") {
        return t(_temp11);
      }
      if (scope.kind === "decrypt_artifacts") {
        return t(_temp12);
      }
      if (scope.kind === "cip_integration") {
        return t(_temp13);
      }
      if (scope.kind === "trigger_kyc") {
        return t(_temp14);
      }
      if (scope.kind === "trigger_kyb") {
        return t(_temp15);
      }
      if (scope.kind === "auth_token") {
        return t(_temp16);
      }
      if (scope.kind === "manage_vault_proxy") {
        return t(_temp17);
      }
      if (scope.kind === "onboarding") {
        return t(_temp18);
      }
      if (scope.kind === "manage_webhooks") {
        return t(_temp19);
      }
      return "";
    };
    $[0] = getLabel;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const getScopeText = t0;
  let t1;
  if ($[3] !== getScopeText || $[4] !== t) {
    t1 = scope_0 => {
      const text = getScopeText(scope_0);
      return isSandboxOnly(scope_0) ? t(_temp20, {
        scope: text
      }) : text;
    };
    $[3] = getScopeText;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default useGetRoleText;
function _temp($) {
  return $.scopes.decryptField;
}
function _temp2($_0) {
  return $_0.scopes.admin;
}
function _temp3($_1) {
  return $_1.scopes.read;
}
function _temp4($_2) {
  return $_2.scopes.onboarding_configuration;
}
function _temp5($_3) {
  return $_3.scopes.api_keys;
}
function _temp6($_4) {
  return $_4.scopes.org_settings;
}
function _temp7($_5) {
  return $_5.scopes.manual_review;
}
function _temp8($_6) {
  return $_6.scopes.write_entities;
}
function _temp9($_7) {
  return $_7.scopes.invoke_vault_proxy.checkbox;
}
function _temp10($_8) {
  return $_8.scopes.decrypt_data;
}
function _temp11($_9) {
  return $_9.scopes.decrypt_onboarding_data;
}
function _temp12($_10) {
  return $_10.scopes.decrypt_artifacts;
}
function _temp13($_11) {
  return $_11.scopes.cip_integration;
}
function _temp14($_12) {
  return $_12.scopes.trigger_kyc;
}
function _temp15($_13) {
  return $_13.scopes.trigger_kyb;
}
function _temp16($_14) {
  return $_14.scopes.auth_token;
}
function _temp17($_15) {
  return $_15.scopes.manage_vault_proxy;
}
function _temp18($_16) {
  return $_16.scopes.onboarding;
}
function _temp19($_17) {
  return $_17.scopes.manage_webhooks;
}
function _temp20($_18) {
  return $_18.scopes.sandboxOnly;
}